export const TRANSLATION_KEY = 'legal_documents_package.upload_documents_request_modal';

export const SEND_REQUEST_TRANSLATION_KEY = `${TRANSLATION_KEY}.send_request_step`;

export const REQUEST_TEXT_CONTROL_TRANSLATION_KEY = `${SEND_REQUEST_TRANSLATION_KEY}.request_text_control`;

export const SUCCESS_STEP_TRANSLATION_KEY = `${TRANSLATION_KEY}.success_step`;

export enum MODAL_STEPS {
    SEND_REQUEST = 'send_request',
    SUCCESS = 'success',
}
